import React from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';

import { OfflineShop, OnlineShop } from './Shop';
import BottomCircle from './BottomCircle';

const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;

const Dummy = styled.div`
  width: 100%;
  height: 188px;

  ${media.mobile`
    height: 120px;
  `}
`;

/** Color Dot */
const Dot = styled.div`
  width: 10px;
  height: 10px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: ${(props) => props.color};

  ${media.mobile`
    margin-bottom: 10px;
  `}
`;

/** Column Title */
const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 1.2px;
  color: #343434;
  margin-bottom: 50px;

  ${media.mobile`
    font-size: 21px;
    letter-spacing: 1px;
  `}
`;

const Desc = styled.div`
  margin: 0 auto;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 18px;
  line-height: 1.78;
  text-align: center;
  color: #444444;

  .mobile.show {
    display: none;
  }

  ${media.mobile`
    font-size: 16px;

    .mobile.hidden {
      display: none;
    }
    .mobile.show {
      display: block;
    }
  `}
`;

const BottomDummy = styled.div`
  width: 100%;
  height: 164px;
`;

const Shoplist = ({color}) => {
  return (
    <Wrapper>
      <Dummy/>
      <Dot color={color}/>
      <Title>OFFLINE SHOP</Title>
      <Desc>
        <div className="mobile hidden">
          구름바이에이치가 수입하는 미국 브랜드 베이비디디(Babydeedee)의<br/>
          오프라인 매장을 안내해드립니다.
        </div>

        <div className="mobile show">
          구름바이에이치가 수입하는 미국<br/>
          브랜드 베이비디디(Babydeedee)의<br/>
          오프라인 매장을 안내해드립니다.
        </div>
      </Desc>
      <OfflineShop/>
      <BottomDummy/>

      <Dot color={color}/>
      <Title>ONLINE SHOP</Title>
      <Desc>
        <div className="mobile hidden">
          구름바이에이치가 수입하는 미국 브랜드 베이비디디(Babydeedee)의<br/>
          온라인 매장을 안내해드립니다.
        </div>

        <div className="mobile show">
          구름바이에이치가 수입하는 미국<br/>
          브랜드 베이비디디(Babydeedee)의<br/>
          온라인 매장을 안내해드립니다.
        </div>
      </Desc>
      <OnlineShop/>
      <BottomCircle color={color}/>
    </Wrapper>
  );
};

export default Shoplist;



// WEBPACK FOOTER //
// ./src/components/Shoplist/index.js